import type { ReportKind } from '../../../types/reportsAdmin.types';
import { REPORTS_COPY } from '../copy';

const TONE: Record<ReportKind, { bg: string; border: string; color: string; label: string }> = {
    GENERATED: {
        bg: 'var(--cpm-purple-tint-13)',
        border: 'transparent',
        color: 'var(--cpm-brand-purple)',
        label: REPORTS_COPY.KIND_GENERATED,
    },
    ALWAYS_ON: {
        bg: 'var(--cpm-info-bg)',
        border: 'var(--cpm-info-border)',
        color: 'var(--cpm-info-text)',
        label: REPORTS_COPY.KIND_ALWAYS_ON,
    },
    DEAD: {
        bg: 'var(--cpm-warning-bg)',
        border: 'var(--cpm-warning-border)',
        color: 'var(--cpm-warning-text)',
        label: REPORTS_COPY.KIND_DEAD,
    },
};

export default function KindBadge({ kind }: { kind: ReportKind }) {
    const tone = TONE[kind] ?? TONE.GENERATED;
    return (
        <span
            className="inline-flex items-center shrink-0"
            style={{
                padding: '3px 9px',
                borderRadius: 'var(--cpm-radius-full)',
                background: tone.bg,
                border: `1px solid ${tone.border}`,
                color: tone.color,
                fontSize: 11,
                fontWeight: 800,
                letterSpacing: '0.03em',
                whiteSpace: 'nowrap',
            }}
        >
            {tone.label}
        </span>
    );
}
